import styled, { css } from 'styled-components';

const disabledStyles = css`
  position: relative;
  * {
    pointer-events: none;
  }
  :before {
    content: '';  
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
    cursor: not-allowed;
  }
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #1f1f1f;
  color: #fff;
`;

export const SettingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #2a2a2a;
  border-bottom: 1px solid #333;
`;

export const DocumentName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #fff;
`;

export const EditIcon = styled.div`
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const TabNavigationContainer = styled.div`
  display: flex;
  background-color: #2a2a2a;
  border-bottom: 1px solid #333;
`;

export const TabButton = styled.button`
  flex: 1;
  padding: 12px 20px;
  background-color: ${props => props.active ? '#1f1f1f' : 'transparent'};
  color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.65)'};
  border: none;
  border-bottom: ${props => props.active ? '2px solid #1890ff' : '2px solid transparent'};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => props.active ? '600' : '400'};
  transition: all 0.2s;
  
  &:hover {
    color: #fff;
    background-color: ${props => props.active ? '#1f1f1f' : '#252525'};
  }
`;

export const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 20px 40px 20px;
  height: 100%;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #1f1f1f;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #555;
    border-radius: 4px;
    
    &:hover {
      background: #777;
    }
  }
  ${props => props.isEditMode && disabledStyles};
`;

export const CollapsibleSection = styled.div`
  margin-bottom: 8px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #2a2a2a;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #2a2a2a;
  color: #fff;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #333;
  }
`;

export const SectionTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const ChevronIcon = styled.span`
  transition: transform 0.2s;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  display: inline-block;
`;

export const SectionContent = styled.div`
  padding: ${props => props.expanded ? '16px' : '0'};
  max-height: ${props => props.expanded ? '5000px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s ease-out;
  background-color: #1f1f1f;
`;

export const StylingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Content = styled.div`
  ${props => props.isEditMode && disabledStyles};
`;

export const FontControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .doc-settings-grouping {
    .fontSelection {
      margin-bottom: 8px !important;
    }
  }
`;

export const FontControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FontLabel = styled.label`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  min-width: 100px;
`;

export const SettingItem = styled.div`
  margin-bottom: 20px;
`;

export const SettingLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
`;

export const SettingValue = styled.div`
  margin-top: 8px;
`;

